<template>
  <div>
    <StaticDataTable class="static-table-list">
      <template v-slot:header>
        <tr>
          <th width="20%">Task Type</th>
          <th width="20%">Charge Type</th>
          <th width="25%">Stock Item</th>
          <th width="15%">Price Override</th>
          <th width="30%"></th>
          <th width="5%">&nbsp;</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="feeInfo of configList" :key="feeInfo.id">
          <td>
            <FormSelect :options="availableTaskTypeLookup" v-model="feeInfo.taskTypeId" @input="listUpdated" />
          </td>
          <td>
            <FormSelect :options="DespatchChargeTypeLookup" v-model="feeInfo.despatchChargeType" @input="listUpdated" />
          </td>
          <td>
            <FormSelect :options="taskTypeStockLookup(feeInfo)" v-model="feeInfo.stockId" @input="listUpdated" />
          </td>
          <td>
            <FormCheckbox v-model="feeInfo.isPriceOverridden" @change="listUpdated" />
          </td>
          <td>
            <template v-if="feeInfo.isPriceOverridden">
              <FormInputCurrency v-show="!isFeePercentageType(feeInfo)" v-model="feeInfo.unitPriceOverride" @input="listUpdated" />
              <FormInputText type="number" v-show="isFeePercentageType(feeInfo)" v-model="feeInfo.unitPriceOverride" addon="%" @input="listUpdated" />
            </template>
          </td>
          <td>
            <ActionDropMenu :tableAction="true">
              <DropdownMenuItem @click="deleteConfig(feeInfo.id)" icon="fa-trash-alt">Delete</DropdownMenuItem>
            </ActionDropMenu>
          </td>
        </tr>
      </template>
      <template v-slot:empty v-if="configList.length == 0">
        No items found
      </template>
    </StaticDataTable>
    <button class="btn btn-white btn-xs" @click.prevent="addFee"><i class="far fa-plus"></i> Add Fee</button>
    
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { DespatchChargeTypes, DespatchChargeTypeLookup, UOMTypes } from '@/store/types'

export default {
  name: 'TaskTypeContactDefaultStock',
  model: {
    event: 'update'
  },
  props: {
    value: Array,
    field: String
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      taskTypeList: [],
      configList: _.cloneDeep(this.value || [])
    }
  },
  watch: {
    value: function() {
      this.configList = _.cloneDeep(this.value || [])
    },
  },
  computed: {
    availableTaskTypes() {
      // Only show task types with available fees
      return this.taskTypeList.filter(taskType => !_.isEmpty(taskType.availableFeeStocks))
    },
    availableTaskTypeLookup() {
      var emptyTaskInfo = [{ value: null, name: 'None' }]

      return _.concat(emptyTaskInfo, this.availableTaskTypes.map(taskType => {
        return {
          value: taskType.id,
          name: taskType.name
        }
      }))
    }
  },
  created() {
    this.DespatchChargeTypeLookup = DespatchChargeTypeLookup
  },
  mounted() {
    this.loading = true

    this.$apiService.tasksService.getTaskTypeList()
    .then(response => {
      this.taskTypeList = response.data
    })
    .catch(err => {
      this.loadingError = 'Error accessing data'
    })
    .finally(() => {
      this.loading = false
    })
  },
  methods: {
    taskTypeStockLookup(feeInfo) {
      var emptyStockInfo = [{ value: null, name: 'None' }]

      var taskType = this.taskTypeList.find(taskType => taskType.id == feeInfo.taskTypeId)
      if(!taskType)
        return emptyStockInfo

      return _.concat(emptyStockInfo, _.compact(taskType.availableFeeStocks.map(stock => {

        // Don't allow percent stocks if charge type is not per order
        let isPercentCharge = (stock.uomType == UOMTypes.percentOfLineItem || stock.uomType == UOMTypes.percentOfOrder)
        if(isPercentCharge && feeInfo.despatchChargeType != DespatchChargeTypes.order)
          return null

        return {
          value: stock.id,
          name: `${stock.code} | ${stock.name}`
        }
      })))
    },
    addFee() {
      this.configList.push({
        id: `temp-id-` + uuidv4(),
        isNew: true,
        taskTypeId: null,
        stockId: null,
        despatchChargeType: DespatchChargeTypes.order,
        isPriceOverridden: false,
        unitPriceOverride: 0
      })
      this.listUpdated()
    },
    isFeePercentageType(feeInfo) {
      var taskType = this.taskTypeList.find(taskType => taskType.id == feeInfo.taskTypeId)
      if(!taskType)
        return false

      var stockInfo = taskType.availableFeeStocks.find(stock => stock.id == feeInfo.stockId)
      if(!stockInfo)
        return false

      return stockInfo.uomType == UOMTypes.percentOfLineItem || stockInfo.uomType == UOMTypes.percentOfOrder
    },
    deleteConfig(id) {
      this.configList = this.configList.filter(config => config.id != id)
      this.listUpdated()
    },
    listUpdated() {
      this.$emit('update', this.configList)
    }
  }
}
</script>